<template>
  <b-modal
    id="delete-app-modal"
    :visible="visible"
    @hidden="hidden"
    centered
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
  >
    <template #modal-header>
      <h5 class="modal-title">حذف برنامه</h5>
    </template>
    <error-messages
      v-if="errorMessages.length > 0"
      :show="showError"
      :dismissible="true"
      @dismissed="dismissedError"
      :messages="errorMessages"
    />
    <p>
      برای حذف برنامه، شناسه‌ی برنامه یعنی
      <span class="text-danger">{{ service.name }}</span>
      را در فیلد زیر وارد کنید:
    </p>
    <b-form @submit.stop.prevent="deleteService">
      <b-form-group>
        <b-input
          type="text"
          v-model="serviceName"
          :placeholder="service.name"
          @update="val => updateInput(val, service)"
        />
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="hidden" :disabled="loading">
        انصراف
      </b-button>
      <loading-btn
        :loading="loading"
        :disabled="okDisabled || loading"
        @click="deleteService"
      >
        حذف برنامه
      </loading-btn>
    </template>
  </b-modal>
</template>

<script>
import { deleteUserService } from "@/services/service";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
export default {
  components: { LoadingBtn, ErrorMessages },
  name: "DeleteAppModal",
  props: {
    service: Object,
    visible: Boolean
  },
  data() {
    return {
      serviceName: "",
      okDisabled: true,
      loading: false,
      showError: false,
      errorMessages: []
    };
  },
  methods: {
    reset: function() {
      this.loading = false;
      this.serviceName = "";
      this.showError = false;
      this.errorMessages = [];
      this.okDisabled = true;
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    dismissedError: function() {
      this.showError = false;
    },
    updateInput: function(val, deleteItem) {
      if (val === deleteItem.name) {
        this.okDisabled = false;
      } else {
        this.okDisabled = true;
      }
    },
    deleteService: async function() {
      this.loading = true;
      const [error, data] = await deleteUserService({
        serviceId: this.service.id
      });
      if (error) {
        this.errorMessages = error;
        this.showError = true;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.loading = false;
          this.$emit("deleteSuccess");
          this.hidden();
        } else {
          this.errorMessages = data.apiErrors;
          this.showError = true;
          this.loading = false;
        }
      }
    }
  }
};
</script>
